import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@infodocs/shared/services/auth.service';

@Injectable({
	providedIn: 'root',
})
export class SupportUserGuard implements CanActivate {
	private readonly auth = inject(AuthService);
	private readonly router = inject(Router);

	canActivate(): boolean | UrlTree {
		if (!this.auth.isSupportUser()) {
			return this.router.createUrlTree(['/portfolio']);
		}

		return true;
	}
}
